import React from "react";
import { Row, Col, Typography, Card } from "antd";
import { RocketOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const InspirePTComingSoonPage: React.FC = () => {
  const imagePaths = [
    require("../assets/IPT_1.png"),
    require("../assets/IPT_2.png"),
    require("../assets/IPT_3.png"),
    require("../assets/IPT_4.png"),
    require("../assets/IPT_5.png"),
    require("../assets/IPT_6.png"),
  ];

  return (
    <div style={{ padding: "40px", background: "#f0f2f5", minHeight: "100vh" }}>
      <Card
        bordered={false}
        style={{
          maxWidth: 900,
          margin: "0 auto 40px auto",
          textAlign: "center",
          borderRadius: 16,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <RocketOutlined style={{ fontSize: 48, color: "#1890ff", marginBottom: 16 }} />
        <Title level={2} style={{ marginBottom: 0 }}>INSPIRE PT Coming Soon</Title>
        <Text type="secondary">A new generation of poker</Text>
      </Card>

      <Row gutter={[16, 16]} justify="center">
        {imagePaths.map((src, idx) => (
          <Col xs={12} sm={8} md={8} lg={8} key={idx}>
            <Card
              hoverable
              cover={<img src={src} alt={`IPT ${idx + 1}`} style={{ borderRadius: 8 }} />}
              style={{ borderRadius: 8 }}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default InspirePTComingSoonPage;
